/** 企业类型 */
export enum EBindingType {
  /** 法人银行卡 */
  Personal = 0,
  /** 对公账户 */
  Company = 1,
}

export const bindingTypeLabel = {
  [EBindingType.Personal]: '法人银行卡',
  [EBindingType.Company]: '对公账户',
};